export default __webpack_public_path__ + "static/media/item4@2x.02226aa5.png";